import { MockAdProvider } from './ads/MockAdProvider';
import type { AdProvider } from './ads/types';

export interface PlatformAdapter {
  readonly kind: 'web' | 'line';
  initialize(): Promise<void>;
  createAdProvider(): AdProvider;
}

export class WebPlatformAdapter implements PlatformAdapter {
  readonly kind = 'web' as const;

  async initialize(): Promise<void> {
    await Promise.resolve();
  }

  createAdProvider(): AdProvider {
    return new MockAdProvider();
  }
}
